<template>
  <div
    class="card p-6 relative transition-all duration-200 hover:-translate-y-0.5 hover:shadow-card"
    :class="highlighted ? 'border-brand-100 shadow-card' : ''"
  >
    <div v-if="highlighted"
      class="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-600 text-white text-2xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full shadow-soft">
      {{ badge }}
    </div>

    <div class="flex items-center gap-3">
      <div :class="['w-10 h-10 rounded-xl flex items-center justify-center', iconWrapClass]">
        <Icon :name="icon" :size="18" />
      </div>
      <div class="flex-1">
        <div class="flex items-center gap-2">
          <h3 class="font-semibold text-ink-900 tracking-tight">{{ mode }}</h3>
          <span v-if="!highlighted" class="badge-neutral text-2xs">{{ badge }}</span>
        </div>
      </div>
    </div>

    <p class="mt-4 text-sm text-ink-600 leading-relaxed">{{ description }}</p>

    <ul class="mt-5 space-y-2">
      <li v-for="f in features" :key="f" class="flex items-start gap-2 text-sm text-ink-700">
        <Icon name="check" :size="14" classes="text-accent-600 mt-0.5 shrink-0" />
        <span>{{ f }}</span>
      </li>
    </ul>

    <router-link to="/pricing"
      class="mt-6 inline-flex items-center gap-1 text-sm font-medium text-brand-700 hover:text-brand-800">
      See plans <Icon name="arrow-right" :size="14" />
    </router-link>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '../ui/Icon.vue';

const props = defineProps({
  mode:        { type: String, required: true },
  badge:       { type: String, default: '' },
  description: { type: String, required: true },
  features:    { type: Array,  required: true },
  icon:        { type: String, default: 'zap' },
  accent:      { type: String, default: 'brand' },
  highlighted: { type: Boolean, default: false },
});

const iconWrapClass = computed(() => ({
  brand:  'bg-brand-50 text-brand-700',
  accent: 'bg-accent-50 text-accent-700',
  ink:    'bg-ink-100 text-ink-700',
}[props.accent]));
</script>
